// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--hire-main-content{
    padding: 10px 130px 100px 130px;
    width: 100%;
    max-width: 1920px;
}

.scl--crr-hire-head-const-box{
    width: 100%;
}

.scl--crr-hire-head-const-box .scl-components-button-RoundSqureButton-primary{
    background: rgba(78, 159, 255, 1);
    width: 91px;
    height: 30px;
}


.scl--crr-hire-filt-const-box {
  width: 100%;
  display: flex;
  align-items: center; /* add this */
  gap: 15px;
  padding-top: 15px;
}

.scl--crr-hire-filt-deparment{
    min-width: 133px;
}

.scl--crr-hire-filt-status{
   min-width: 100px;
}

.scl--crr-hire-filt-type{
    min-width: 95px;
}

.scl--crr-hire-filt-search{
    width: 279px;
}

.scl--crr-hire-tabl-const-box{
    margin-top: 10px;
}

.scl--crr-hire-tabl-const-box .scl--components-table-dynamicTable-main thead th{
    padding-left: 0px;
}

.scl--crr-hire-tabl-const-box .scl--components-table-dynamicTable-select-cell-content{
    padding-left: 0px;
}

.scl--crr-hire-tabl-const-box .scl--components-table-dynamicTable-main tbody td::first-letter{
    text-transform: uppercase;
}

.scl--crr-hire-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(2), .scl--crr-hire-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(4), .scl--crr-hire-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(5), .scl--crr-hire-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(6), .scl--crr-hire-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(7){
    color: var(--typography-text-body-secondary);
}
.scl--crr-hire-tabl-const-box .scl--components-table-dynamicTable-main tbody td {
  max-width: 0; /* this is the key — forces fixed layout to actually clip */
      padding-left: 0px;
}

.scl--crr-hire-tabl-const-box .scl--components-table-dynamicTable-clickable-cell {
  width: 100%;
  overflow: hidden;
    text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block; /* change from inline-flex to block */
}

.scl--crr-hire-action-const-sty{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
}

.scl--crr-hire-action-const-sty span{
    padding: 0;
    margin: 0;
    color: rgba(138, 139, 143, 0.2);
    font-size: 12px;
}

.scl--crr-hire-action-const-sty button{
    width: 19px;
    height: 19px;
    border: none;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border-radius: 4px;
    margin: 0;
    cursor: pointer;
}

.scl--crr-hire-action-const-sty button path{
    stroke: #8A8B8F;
}
.scl--crr-hire-edit-btn-const-sty:hover {
    background-color: rgba(156, 156, 156, 0.24);
}
.scl--crr-hire-tras-btn-const-sty:hover{
    background-color: rgba(226, 173, 173, 0.24);
}

.scl--crr-hire-tras-btn-const-sty svg path{
    stroke: rgba(254, 86, 107, 1);
}

.scl--crr-hire-tras-btn-const-sty{
    border-radius: 4px;
    transition: all 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
}

.scl--crr-hire-eye-btn-const-sty svg path, .scl--crr-hire-eye-btn-const-sty svg circle{
    stroke: rgba(138, 139, 143, 1);
}

.scl--crr-hire-eye-btn-const-sty{
    transition: all 0.3s;
    border-radius: 4px;
}

.scl--crr-hire-eye-btn-const-sty:hover{
    background-color: rgba(156, 156, 156, 0.24);
}

.scl--crr-hire-eye-btn-const-sty:hover svg , .scl--crr-hire-eye-btn-const-sty:hover svg circle{
    stroke: black;
}`, "",{"version":3,"sources":["webpack://./src/page-controller-mod/page-serv/career/css/hire.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;IAC/B,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iCAAiC;IACjC,WAAW;IACX,YAAY;AAChB;;;AAGA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB,EAAE,aAAa;EAClC,SAAS;EACT,iBAAiB;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;GACG,gBAAgB;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,4CAA4C;AAChD;AACA;EACE,YAAY,EAAE,2DAA2D;MACrE,iBAAiB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;IACd,gBAAgB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc,EAAE,qCAAqC;AACvD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,SAAS;IACT,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,2CAA2C;AAC/C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".scl--hire-main-content{\n    padding: 10px 130px 100px 130px;\n    width: 100%;\n    max-width: 1920px;\n}\n\n.scl--crr-hire-head-const-box{\n    width: 100%;\n}\n\n.scl--crr-hire-head-const-box .scl-components-button-RoundSqureButton-primary{\n    background: rgba(78, 159, 255, 1);\n    width: 91px;\n    height: 30px;\n}\n\n\n.scl--crr-hire-filt-const-box {\n  width: 100%;\n  display: flex;\n  align-items: center; /* add this */\n  gap: 15px;\n  padding-top: 15px;\n}\n\n.scl--crr-hire-filt-deparment{\n    min-width: 133px;\n}\n\n.scl--crr-hire-filt-status{\n   min-width: 100px;\n}\n\n.scl--crr-hire-filt-type{\n    min-width: 95px;\n}\n\n.scl--crr-hire-filt-search{\n    width: 279px;\n}\n\n.scl--crr-hire-tabl-const-box{\n    margin-top: 10px;\n}\n\n.scl--crr-hire-tabl-const-box .scl--components-table-dynamicTable-main thead th{\n    padding-left: 0px;\n}\n\n.scl--crr-hire-tabl-const-box .scl--components-table-dynamicTable-select-cell-content{\n    padding-left: 0px;\n}\n\n.scl--crr-hire-tabl-const-box .scl--components-table-dynamicTable-main tbody td::first-letter{\n    text-transform: uppercase;\n}\n\n.scl--crr-hire-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(2), .scl--crr-hire-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(4), .scl--crr-hire-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(5), .scl--crr-hire-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(6), .scl--crr-hire-tabl-const-box .scl--components-table-dynamicTable-main tbody td:nth-child(7){\n    color: var(--typography-text-body-secondary);\n}\n.scl--crr-hire-tabl-const-box .scl--components-table-dynamicTable-main tbody td {\n  max-width: 0; /* this is the key — forces fixed layout to actually clip */\n      padding-left: 0px;\n}\n\n.scl--crr-hire-tabl-const-box .scl--components-table-dynamicTable-clickable-cell {\n  width: 100%;\n  overflow: hidden;\n    text-align: left;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: block; /* change from inline-flex to block */\n}\n\n.scl--crr-hire-action-const-sty{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 5px;\n}\n\n.scl--crr-hire-action-const-sty span{\n    padding: 0;\n    margin: 0;\n    color: rgba(138, 139, 143, 0.2);\n    font-size: 12px;\n}\n\n.scl--crr-hire-action-const-sty button{\n    width: 19px;\n    height: 19px;\n    border: none;\n    background: transparent;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    border-radius: 4px;\n    margin: 0;\n    cursor: pointer;\n}\n\n.scl--crr-hire-action-const-sty button path{\n    stroke: #8A8B8F;\n}\n.scl--crr-hire-edit-btn-const-sty:hover {\n    background-color: rgba(156, 156, 156, 0.24);\n}\n.scl--crr-hire-tras-btn-const-sty:hover{\n    background-color: rgba(226, 173, 173, 0.24);\n}\n\n.scl--crr-hire-tras-btn-const-sty svg path{\n    stroke: rgba(254, 86, 107, 1);\n}\n\n.scl--crr-hire-tras-btn-const-sty{\n    border-radius: 4px;\n    transition: all 0.3s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.scl--crr-hire-eye-btn-const-sty svg path, .scl--crr-hire-eye-btn-const-sty svg circle{\n    stroke: rgba(138, 139, 143, 1);\n}\n\n.scl--crr-hire-eye-btn-const-sty{\n    transition: all 0.3s;\n    border-radius: 4px;\n}\n\n.scl--crr-hire-eye-btn-const-sty:hover{\n    background-color: rgba(156, 156, 156, 0.24);\n}\n\n.scl--crr-hire-eye-btn-const-sty:hover svg , .scl--crr-hire-eye-btn-const-sty:hover svg circle{\n    stroke: black;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
